import { Link } from 'react-router-dom';
import { popularMovies } from '@/mocks/movies';

export default function PopularSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500">全网最受欢迎的影视TOP10</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {popularMovies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex items-center gap-4 bg-background-100 rounded-xl p-4 hover:bg-background-200/60 transition-all duration-300"
              data-product-shop
            >
              {/* Rank */}
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                {index < 3 ? (
                  <span className={`font-heading text-2xl font-bold ${index === 0 ? 'text-accent-500' : index === 1 ? 'text-secondary-500' : 'text-secondary-400'}`}>
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-sm font-medium text-foreground-500">
                    {index + 1}
                  </span>
                )}
              </div>

              {/* Poster */}
              <div className="relative w-16 h-20 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={movie.posterImage}
                  alt={movie.title}
                  title={`${movie.title} - 小辣椒影院高清电影免费在线观看`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {movie.title}
                </h3>
                <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                  <span className="bg-primary-100 text-primary-700 px-1.5 py-0.5 rounded whitespace-nowrap">{movie.tags[0]}</span>
                  <span>{movie.region}</span>
                  <span>{movie.year}</span>
                </div>
              </div>

              {/* Rating and Views */}
              <div className="flex-shrink-0 text-right">
                <div className="flex items-center gap-1 text-sm">
                  <i className="ri-star-fill text-accent-500 w-3.5 h-3.5 flex items-center justify-center"></i>
                  <span className="font-medium text-foreground-800">{movie.rating}</span>
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">
                  {movie.views >= 10000 ? `${(movie.views / 10000).toFixed(0)}万播放` : `${movie.views}播放`}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}